import { ActionTypeKeys, ActionTypes } from 'common/actions'

import { Product } from 'even-ts-static'

export type LoadingState = {
  [key in Product]?: {
    endTime?: Date
    error?: boolean
    loading?: number
    startTime?: Date
    errorStatus?: number
  }
}

export const initialLoadingState: LoadingState = {
  [Product.Deposits]: {
    endTime: undefined,
    error: false,
    loading: 0,
    startTime: undefined,
  },
  [Product.LifeInsurance]: {
    endTime: undefined,
    error: false,
    loading: 0,
    startTime: undefined,
  },
  [Product.Loan]: {
    endTime: undefined,
    error: false,
    loading: 0,
    startTime: undefined,
  },
  [Product.CreditCard]: {
    endTime: undefined,
    error: false,
    loading: 0,
    startTime: undefined,
  },
}

// eslint-disable-next-line complexity
const reducer = (state: LoadingState = initialLoadingState, action: ActionTypes) => {
  let currentLoadingCount
  let loadingCount
  let nextState

  switch (action.type) {
    case ActionTypeKeys.FETCH_PREVIEW_OFFERS_START:
    case ActionTypeKeys.FETCH_RATE_TABLES_START:
    case ActionTypeKeys.FETCH_REDEMPTION_TYPES_START:
    case ActionTypeKeys.FETCH_ROUTER_QUESTIONS_START:
    case ActionTypeKeys.REWARD_VALUE_CALCULATION_START:
      nextState = { ...state }
      nextState[action.product] = {
        ...state[action.product],
        endTime: null,
        loading: (state[action.product]?.loading ?? 0) + 1,
        startTime: new Date(),
      }
      return nextState
    case ActionTypeKeys.FETCH_PREVIEW_OFFERS_SUCCESS:
    case ActionTypeKeys.FETCH_RATE_TABLES_SUCCESS:
    case ActionTypeKeys.FETCH_REDEMPTION_TYPES_SUCCESS:
    case ActionTypeKeys.FETCH_ROUTER_QUESTIONS_SUCCESS:
    case ActionTypeKeys.REWARD_VALUE_CALCULATION_SUCCESS:
      // don't decrement past 0
      currentLoadingCount = state[action.product]?.loading ?? 0
      loadingCount = currentLoadingCount > 0 ? currentLoadingCount - 1 : 0
      nextState = { ...state }
      nextState[action.product] = {
        ...state[action.product],
        endTime: new Date(),
        error: false,
        loading: loadingCount,
      }
      return nextState
    case ActionTypeKeys.FETCH_RATE_TABLES_FAIL:
    case ActionTypeKeys.FETCH_PREVIEW_OFFERS_FAIL:
      currentLoadingCount = state[action.product]?.loading ?? 0
      loadingCount = currentLoadingCount > 0 ? currentLoadingCount - 1 : 0
      nextState = { ...state }
      nextState[action.product] = {
        ...state[action.product],
        error: true,
        errorStatus: action.errorStatus,
        loading: loadingCount,
      }
      return nextState
    case ActionTypeKeys.FETCH_RATE_TABLES_CANCEL:
    case ActionTypeKeys.FETCH_REDEMPTION_TYPES_ERROR:
    case ActionTypeKeys.REWARD_VALUE_CALCULATION_ERROR:
      // don't decrement past 0
      currentLoadingCount = state[action.product]?.loading ?? 0
      loadingCount = currentLoadingCount > 0 ? currentLoadingCount - 1 : 0
      nextState = { ...state }
      nextState[action.product] = {
        ...state[action.product],
        error: false,
        loading: loadingCount,
      }
      return nextState
    default:
      return state
  }
}

export default reducer
